module.exports = __webpack_public_path__ + "img/lt.46c0f435.svg";